import React, { useContext } from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { Form, Input, Row, Col } from "antd";

import { CardContainer } from "../../component/customComponent/CardContainer";
import { FormFields } from "./FormFields";
import { DemographicConflictFormItem, ConflictIndicator } from "./DemographicConflictFormItem";
import { ManagePatientDetailsContext } from "./context";

const { TextArea } = Input;

const StyledTextArea = styled(TextArea)`
  textarea {
    border-radius: 4px;
  }
`;

const NumberInput = styled(Input)`
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  border-radius: 4px;
  // width: 316px;
`;

const ManagePatientDetailsMedical = ({ t }) => {
  const { demographicsFormData, replaceDemographicsPendingConflict, ignoreDemographicsPendingConflict } =
    useContext(ManagePatientDetailsContext);
  // Height is stored as a single `patientHeight` demographic but rendered as two
  // fields, so its conflict is keyed by `patientHeight` and covers both inputs.
  const heightConflict = demographicsFormData.conflicts[FormFields.patientHeight];

  return (
    <CardContainer>
      <Row
        justify="center"
        gutter={[0, 4]}
        style={{ display: "flex", justifyContent: "flex-start", gap: 20 }}
        id="manage-patient-details-medical-information"
      >
        <Col style={{ position: "relative", display: "flex", gap: 20 }}>
          <Form.Item
            style={{ width: "120px" }}
            name={[FormFields.patientHeightFeet]}
            colon="false"
            label={t("managePatientDetails.patient_height")}
          >
            <NumberInput
              style={{ width: "100%" }}
              min={0}
              disabled={!!heightConflict}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = t("managePatientDetails.patient_height_placeholder"))}
              type={"number"}
              placeholder={0}
              suffix="ft"
            />
          </Form.Item>
          <Form.Item name={[FormFields.patientHeightInch]} colon="false" label=" " style={{ width: "120px" }}>
            <NumberInput
              style={{ width: "100%" }}
              min={0}
              disabled={!!heightConflict}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = t("managePatientDetails.patient_height_placeholder"))}
              type={"number"}
              placeholder={0}
              suffix="in"
            />
          </Form.Item>
          {heightConflict && (
            <ConflictIndicator
              conflict={heightConflict}
              onClickReplace={() => replaceDemographicsPendingConflict(FormFields.patientHeight)}
              onClickIgnore={() => ignoreDemographicsPendingConflict(FormFields.patientHeight)}
            />
          )}
        </Col>
        <Col style={{ width: "120px", position: "relative" }}>
          <DemographicConflictFormItem
            name={FormFields.patientWeight}
            colon="false"
            label={t("managePatientDetails.patient_weight")}
          >
            <NumberInput
              style={{ width: "100%" }}
              min={0}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = t("managePatientDetails.patient_weight_placeholder"))}
              type={"number"}
              placeholder={0}
              suffix="lbs"
            />
          </DemographicConflictFormItem>
        </Col>
      </Row>

      <Row justify="center">
        <Col style={{ width: "100%", position: "relative" }}>
          <DemographicConflictFormItem
            name={FormFields.patientAllergies}
            colon="false"
            label={t("managePatientDetails.patient_allergies")}
          >
            <StyledTextArea
              placeholder={t("managePatientDetails.patient_allergies_placeholder")}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = t("managePatientDetails.patient_allergies_placeholder"))}
              showCount
              maxLength={800}
              autoSize={{ minRows: 6 }}
            />
          </DemographicConflictFormItem>
        </Col>
      </Row>
    </CardContainer>
  );
};

export default compose(withTranslation())(ManagePatientDetailsMedical);
